import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Copy, Facebook, Share2, Twitter } from "lucide-react";
import { Post } from "@/types/post";

interface ShareDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedPost: Post | null;
  onShare: (type: string, postId: string) => void;
}

export function ShareDialog({
  open,
  onOpenChange,
  selectedPost,
  onShare
}: ShareDialogProps) {
  if (!selectedPost) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Compartilhar</DialogTitle>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-4 mt-4">
          <Button
            variant="outline"
            className="flex items-center gap-2"
            onClick={() => onShare('whatsapp', selectedPost.id)}
          >
            <Share2 className="h-5 w-5" />
            WhatsApp
          </Button>
          <Button
            variant="outline"
            className="flex items-center gap-2"
            onClick={() => onShare('facebook', selectedPost.id)}
          >
            <Facebook className="h-5 w-5" />
            Facebook
          </Button>
          <Button
            variant="outline"
            className="flex items-center gap-2"
            onClick={() => onShare('twitter', selectedPost.id)}
          >
            <Twitter className="h-5 w-5" />
            Twitter
          </Button>
          <Button
            variant="outline"
            className="flex items-center gap-2"
            onClick={() => onShare('copy', selectedPost.id)}
          >
            <Copy className="h-5 w-5" />
            Copiar Link
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}